import InvestmentCreateModal from "./InvestmentCreateModal"

export default InvestmentCreateModal
